module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAAALCAIAAAAY648/AAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNy8xNS8yMOPyYu4AAAB4SURBVEiJY2SY+Z8BN/ifhkeSMDBZh0/2TBD5Jqcfxic705Z8k9HArOv4ZJmoZs+IBKPBRxEYDT6KwGjwUQRGg48iMBp8FIHR4KMIjAYfRWA0+CgCjPuf4ut1OEhRZPrZN/hkjUXIN/nWR3yyavzkm4wGnn3DJwsAmyQRXG/kojIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail-tit.png
// module id = Eixm
// module chunks = 1